import StringUuidGenerator from './StringUuidGenerator';
import UuidGenerator from './UuidGenerator';

export const elementUuids = new UuidGenerator();
export const conditionUuids = new StringUuidGenerator();
export const conditionOptionUuids = new StringUuidGenerator();
